// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// 转换es6代码兼容ie
import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
// 仓库
import store from './store'
import router from './router'
// 公共的样式
import './style/index.css'
import './assets/fonts/iconfont.css'
// element ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './sealFilter/permission'
import { vueBaberrage } from 'vue-baberrage'
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload);
Vue.use(vueBaberrage)
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
Vue.config.productionTip = false
Vue.use(ElementUI)

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js